export default function ($) {

  $('.js-open-product-categories-filter').on('click', function () {
    $('.js-product-categories-filter').addClass('open');
  });

  $('.js-product-categories-filter-close, .product-categories-filters-overlay').on('click', function () {
    $('.js-product-categories-filter').removeClass('open');
  });

  if ($('#product-filters').length > 0) {

    $('.js-open-product-filters').on('click', function () {
      $('.js-product-filters').addClass('open');
    });

    $('.js-product-filters-close, .product-filters-overlay').on('click', function () {
      $('.js-product-filters').removeClass('open');
    });

    function compare_object_text_natural(object_a, object_b) {
      return object_a[0].text.localeCompare(
        object_b[0].text,
        undefined,
        { numeric: true, sensitivity: 'base' } // meaning sort natural
      )
    }

    function update_ui_after_brand_change(filters) {
      // cleanup options
      $('.js-year-select').children().remove()
      $('.js-model-select').children().remove()

      // disable selects by default
      $('.js-year-select').prop('disabled', 'disabled')
      $('.js-model-select').prop('disabled', 'disabled')

      // generate options
      if (Object.keys(filters.years).length > 0) {
        $('.js-year-select').prop('disabled', false)

        var options = []

        var default_option = $('<option></option>').prop('selected', 'selected')

        options.push(default_option)

        $.each(filters.years, function (key, value) {
          if (!value) { return; }
          var option = $('<option></option>').val(key).text(key)
          options.push(option)
        })

        $('.js-year-select').append(options.sort(compare_object_text_natural))
      }
    }

    function update_ui_after_year_change(filters) {
      // cleanup options
      $('.js-model-select').children().remove()

      // disable selects by default
      $('.js-model-select').prop('disabled', 'disabled')

      if (filters === undefined) {
        return; // blank model case
      }

      // generate years options
      if (Object.keys(filters.models).length > 0) {

        $('.js-model-select').prop('disabled', false)

        var options = []

        var default_option = $('<option></option>').prop('selected', 'selected')
        options.push(default_option)

        $.each(filters.models, function (key, value) {
          var option = $('<option></option>').val(value.model_id).text(value.label)
          options.push(option)
        })

        $('.js-model-select').append(options.sort(compare_object_text_natural))
      }
    }

    var filter_data = $('#product-filters').data('product-filters')

    $('.js-brand-select').change(function (event) {
      var brand_id = $(event.target).val()

      update_ui_after_brand_change(filter_data.find((element) => element.brand_id == brand_id))
    })

    $('.js-year-select').change(function (event) {
      var brand_id = $('.js-brand-select option:selected').val()
      var year = $(event.target).val()

      update_ui_after_year_change(filter_data.find((element) => element.brand_id == brand_id).years[year])
    })

  }
}
